import { useEffect } from "react";
import { db } from "../../firebase/config";
import { useDispatch } from "react-redux";
import { setInitVisibility } from "../../store/site/actions/setInitVisibility";
import { SiteStateResponse } from "../types/SiteStateResponse";

export default function useSiteState() {
  const dispatch = useDispatch();

  useEffect(() => {
    db.collection("state").onSnapshot((snapshot) => {
      if (snapshot.empty) {
        console.log("NO SITE STATE FOUND");
        dispatch(
          setInitVisibility({
            data: {
              isOnline: false,
              isLocalOnline: false,
              date: "25 e 26 Maggio",
              anno: "2024",
            },
            hasError: true,
            checked: true,
            usedHooks: ["useSiteState"],
          }),
        );
      } else {
        let siteState: SiteStateResponse[] = [];
        snapshot.docs.forEach((doc) => {
          siteState = [...siteState, doc.data() as SiteStateResponse];
        });
        dispatch(
          setInitVisibility({
            data: {
              isOnline: siteState[0].isOnline,
              isLocalOnline: siteState[0].isLocalOnline,
              date: siteState[0].date,
              anno: siteState[0].anno,
            },
            hasError: false,
            checked: true,
            usedHooks: ["useSiteState"],
          }),
        );
      }
    });
  }, [dispatch]);
}
